/**
 * The shortest password a new account may have. It matches the setting of the Supabase project
 * (Authentication → Minimum password length, docs/SUPABASE.md §2): length is what counts, there is
 * no obligation to mix cases and digits. The server has the last word; the screens check this too
 * so that the form says what is wanted before it asks.
 */
export const PASSWORD_MIN_LENGTH = 10;

export const isAcceptablePassword = (password: string): boolean =>
  password.length >= PASSWORD_MIN_LENGTH;
